import { useQuery } from "@tanstack/react-query";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";

const path = `${baseUrl}/users`;

export const { useGetAll: useAllUser } = apiCrudBuilder(path, "User", {
  cacheTime: 3600000,
  staleTime: 3600000,
});

export const useAllMyPermissions = (userId, options) => {
  let userIdForRequest = !userId ? "me" : userId;
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["User", "permissions", userIdForRequest],
    queryFn: () =>
      appAxios.get(`${path}/${userIdForRequest}/permissions/`).then((res) => {
        return res.data;
      }),
  });
};

export const useUserCountDeals = (userId, options) => {
  let userIdForRequest = !userId ? "me" : userId;
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["User", "countDeals", userIdForRequest],
    queryFn: () =>
      appAxios.get(`${path}/${userIdForRequest}/count/deal/`).then((res) => {
        return res.data;
      }),
    cacheTime: 60000,
    staleTime: 60000,
  });
};
export const useUserCountSourcings = (userId, options) => {
  let userIdForRequest = !userId ? "me" : userId;
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["User", "countSourcings", userIdForRequest],
    queryFn: () =>
      appAxios
        .get(`${path}/${userIdForRequest}/count/sourcing/`)
        .then((res) => {
          return res.data;
        }),
    cacheTime: 60000,
    staleTime: 60000,
  });
};
